import BaseCommand from "@/models/api/commands/BaseCommand";

export class CopyAttributeToAllBookingItemCommand extends BaseCommand {
  CommandName = "CopyAttributeToAllBookingItem";
  Command: {
    AttributeTmpId: string;
    BookingItemTmpId: string;
    Overwrite: boolean;
  };
  constructor(
    sessionId: string,
    operationId: string,
    bookingItemTmpId: string,
    attributeTmpId: string,
    overwrite: boolean
  ) {
    super(sessionId, operationId);
    this.Command = { AttributeTmpId: attributeTmpId, BookingItemTmpId: bookingItemTmpId, Overwrite: overwrite };
  }
}
